
// import {DatePicker} from 'Electron Gateway_react_ui'
import './App.css';
import '@/assets/css/animate.min.css'
// import 'Electron Gateway_react_ui/dist/app.css';
import { BrowserRouter, Route, Router, Routes, useRoutes } from 'react-router-dom'
import { Suspense } from 'react'
import route from './route'
import NavBar from '@/components/NavBar'
import BottomPage from '@/components/BottomPage'

function App() {
  const RouteRender = () => {
    const rs = useRoutes(route)
    return rs
  }
  return (
    <div className="App">
      <BrowserRouter>
        <NavBar />
        <div className='app_warp'>
          <Suspense fallback={() => <div className='loading'></div>}>
            <RouteRender></RouteRender>
          </Suspense>
        </div>

        <BottomPage />
      </BrowserRouter>

    </div>
  );
}

export default App;
